import dayjs from 'dayjs';

export const dateDisplayBasic = (isoDate: string) => {
  // Convert ISO UTC datetime to local timezone and generate display text
  // console.log("Creating date display,", isoDate);
  return dayjs(isoDate)
    // .subtract(new Date().getTimezoneOffset(), 'minute')
    .format('MMMM D, YYYY');
}

export const dateTimeDisplay = (isoDate: string) => {
  return dayjs(isoDate)
    // .add(new Date().getTimezoneOffset(), 'minute')
    .format('MMMM D, YYYY  h:mm:ss a');
};
